export class ViewerDisplayEvent {
    type: string;
    workId: string;
    attachmentId: string;
    name: string;
    fullUrl: string;
    error ?: string ;
}